const filterDeleted = (collection = []) => {
	return collection.filter((el) => !el.isDeleted);
};

export default filterDeleted;
